export const CircleInfoIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99967 0.833984C4.93706 0.833984 0.833008 4.93804 0.833008 10.0007C0.833008 15.0633 4.93706 19.1673 9.99967 19.1673C15.0623 19.1673 19.1663 15.0633 19.1663 10.0007C19.1663 4.93804 15.0623 0.833984 9.99967 0.833984ZM9.99967 5.83398C9.53944 5.83398 9.16634 6.20708 9.16634 6.66732C9.16634 7.12756 9.53944 7.50065 9.99967 7.50065H10.008C10.4682 7.50065 10.8413 7.12756 10.8413 6.66732C10.8413 6.20708 10.4682 5.83398 10.008 5.83398H9.99967ZM10.833 10.0007C10.833 9.54041 10.4599 9.16732 9.99967 9.16732C9.53944 9.16732 9.16634 9.54041 9.16634 10.0007V13.334C9.16634 13.7942 9.53944 14.1673 9.99967 14.1673C10.4599 14.1673 10.833 13.7942 10.833 13.334V10.0007Z"
        fill="currentColor"
      />
    </svg>
  );
};
